const defaultState = {
  identityHost: 'iam.gasbuddy.com',
};

export default function configReducer(state = defaultState) {
  return state;
}
